import {
  track as _trackFromPackage,
  getAttributes as _getAttributesFromPackage,
} from '@updater-core/lib/tracker';
import { isEnv } from '../../environment';
import { ENVS } from '../../constants';
import { reduxStore } from '../redux';

let _track = _trackFromPackage;
let _getAttributes = _getAttributesFromPackage;

export const getMoveIQAttributes = () => {
  const {
    eligible,
    moveType,
    loadingEligibility,
    homeSize,
  } = reduxStore().getState();
  return !loadingEligibility
    ? {
        moveTypes: moveType ? [moveType.toUpperCase()] : [],
        presence: eligible,
        eligible,
        moveType,
        homeSize,
      }
    : {};
};

export const getAttributes = () => _getAttributes();

export const track = (attrs) => {
  const attributes =
    attrs.domain === 'mover'
      ? { metadata: getMoveIQAttributes() }
      : getMoveIQAttributes();

  const details = { ...attributes, ...attrs.details };

  if (isEnv(ENVS.DEVELOPMENT, ENVS.TEST, ENVS.STAGING, ENVS.UPDATRON)) {
    /* eslint-disable no-console */
    console.log(
      `[analytics] Tracking: ${attrs.domain || 'moveiq'}.${attrs.object}.${
        attrs.verb
      }`,
      details
    );
    /* eslint-enable no-console */
  }

  return _track({
    domain: 'moveiq',
    ...attrs,
    details,
  });
};

export const setTracker = (tracker) => {
  _track = tracker;
};

export const setGetAttributes = (getAttributes) => {
  _getAttributes = getAttributes;
};
